import { LocationType } from 'domain/entity/location';

export const getHierarchyIcon = (locationType: LocationType): string => {
    switch (locationType) {
        case LocationType.BRANCH:
            return 'location_zone';
        case LocationType.LEAF:
            return 'location';
        case LocationType.SECTION:
            return 'location_sub';
        case LocationType.ROOT:
        default:
            return 'world_outline';
    }
};
